// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"4970c0fa","703":"2e3be7d7","839":"c87eeef6"}[chunkId] + ".chunk.js";
};